import { render } from "./Legacy.vue?vue&type=template&id=16498044&lang=pug"
import script from "./Legacy.vue?vue&type=script&lang=js"
export * from "./Legacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__